import clsx from 'clsx';
import styles from './styles.module.scss';

type ApartmentPlanListItemProps = {
  image: string | null;
  alt?: string;
  selected: boolean | null;
  className?: string;
  onClick: () => void;
};

const ApartmentPlanListItem: React.FC<ApartmentPlanListItemProps> = (props) => {
  const { image, alt = '', selected, className, onClick } = props;

  return (
    <button
      type='button'
      onClick={onClick}
      className={clsx(styles.button, selected && styles.selected, className)}
    >
      <img alt={alt} src={image ? image : undefined} height={124} width={124} />
    </button>
  );
};

export default ApartmentPlanListItem;
